export function getUrlQuery(queryParams) {
    return Object.keys(queryParams).map(function(k) {
        return `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`;
    }).join('&')
}
export function isValidURL(str) {
    let url;

    try {
        url = new URL(str);
    } catch (_) {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
}


export function paymentUrl(uuid) {
    return `/payments/create/${uuid}`;
}



// WEBPACK FOOTER //
// ./src/js/utils/url.js